<template>
  <my-view :OrderSuccess="OrderSuccess" :PtOrderSuccess="PtOrderSuccess" :SingleOrderSuccess="SingleOrderSuccess"></my-view>
</template>

<script>
import {
  OrderSuccess,
  PtOrderSuccess,
  SingleOrderSuccess,
} from "@/pages/page1/api/modules/order";

import MyView from "@/pages/publicView/paymentProcess/successPay_view.vue";

export default {
  components: { MyView },
  data() {
    return {
      OrderSuccess,
      PtOrderSuccess,
      SingleOrderSuccess,
    };
  },
};
</script>